module.exports = __webpack_public_path__ + "img/基于复杂生产经营条件下的煤炭企业精益管理—山东能源淄博矿业集团有限责任公司—1-1.d86a48f4.jpg";